import React, { useRef } from "react";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

export const ModalEditarTipoCompra = (props) => {
    const toggle = () => props.activarModalEditarTipoCompra(props.modalEditarTipoCompraStatus);
    const { modalEditarTipoCompraStatus, actualizarTiposCompras, tipoCompras } = props;

    // console.log(tipoCompras)

    const tipoCompraRef = useRef("");

    return (
        <Modal isOpen={modalEditarTipoCompraStatus} toggle={toggle} size="lg" backdrop="static">
          <ModalHeader className="block-example border-bottom " toggle={toggle}>
            Actualizar tipo de compra
          </ModalHeader>
          <ModalBody>
            <div>
              <label>Tipo de compra</label>
              <input
                type="text"
                className="form-control text-dark"
                id="nombre"
                ref={tipoCompraRef}
                required
                defaultValue={ tipoCompras !== undefined ? tipoCompras.nombre : tipoCompraRef }
                placeholder="Digite el tipo de compra"
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="row">
              <div className="">
                <button
                  className="btn btn-danger"
                  onClick={(e) => {
                    e.preventDefault();
                    props.activarModalEditarTipoCompra(props.modalEditarTipoCompraStatus);
                  }}
                >
                  Cancelar
                </button>
              </div>
              <div className="ml-3">
                  <button
                  className="btn btn-primary"
                  onClick={(e) => {
                      e.preventDefault();
                      actualizarTiposCompras(tipoCompras.tipoCompraId,tipoCompraRef.current.value);
                  }}
                  >
                  Actualizar
                  </button>
              </div>
            </div>
      
          </ModalFooter>
        </Modal>
      );
      
};
